export function lastFirmwaresReducer(PRELOAD) {
    const initial = PRELOAD.last_firmwares || {};
    return (state = initial) => state;
}
